import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  ActivationStatus,
  ListVendorAccountMetricsFilterOptions,
  ListVendorAccountMetricsRequest,
  PartnerEngagementApiService,
} from '@vendasta/marketplace-analytics';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { VENDOR_ID } from '../../../tokens';

@Component({
  selector: 'app-pending-activation-banner',
  templateUrl: './pending-activation-banner.component.html',
  styleUrls: ['./pending-activation-banner.component.scss'],
})
export class PendingActivationBannerComponent implements OnInit {
  hasPendingActivationRequests$: Observable<boolean>;

  constructor(
    @Inject(VENDOR_ID) private vendorId$: Observable<string>,
    private router: Router,
    private partnerEngagementApiService: PartnerEngagementApiService,
  ) {}

  routeToPendingActivationsRequest(): void {
    this.router.navigate(['/accounts/pending-activations']);
  }

  ngOnInit(): void {
    this.hasPendingActivationRequests$ = this.vendorId$.pipe(
      switchMap((vendorId) => {
        return this.partnerEngagementApiService.listVendorAccountMetrics(
          new ListVendorAccountMetricsRequest({
            vendorId: vendorId,
            pageSize: 1,
            filterOptions: new ListVendorAccountMetricsFilterOptions({
              activationStatuses: [ActivationStatus.ACTIVATION_STATUS_PENDING_ACTIVATION],
            }),
          }),
        );
      }),
      map((response) => {
        return response.vendorAccountMetrics?.length > 0;
      }),
    );
  }
}
